import PropTypes from 'prop-types';
import React from 'react';
import {
  Card,
  Subtitle1,
} from '@fluentui/react-components';
import { Lift } from './lift';
import { ConfidenceLevel } from './confidence-level';
import { TreatmentControl } from './treatment-control';
import { useStyles } from './styles';

export const PerformanceCard = ({
  color,
  confidence,
  control,
  lift,
  liftHelpTopic,
  subtitle,
  title,
  treatment,
}) => {
  const styles = useStyles();
  const className = `${title.toLowerCase().replace(/ /g, '-')}-overview`;

  return (
    <div className={className}>
      <Card
        className={styles.card}
        orientation="horizontal"
        style={{ borderColor: color }}
      >
        <section>
          <Subtitle1>{title}</Subtitle1>
          <Lift
            color={color}
            helpTopic={liftHelpTopic}
            label={subtitle}
            value={lift}
          />
          <ConfidenceLevel value={confidence} />
        </section>
        <section>
          <TreatmentControl
            color={color}
            control={control}
            treatment={treatment}
          />
        </section>
      </Card>
    </div>
  );
};

PerformanceCard.propTypes = {
  color: PropTypes.string.isRequired,
  confidence: PropTypes.string.isRequired,
  control: PropTypes.number.isRequired,
  lift: PropTypes.number.isRequired,
  liftHelpTopic: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  treatment: PropTypes.number.isRequired,
};
